import * as SentryLib from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

export function initSentry() {
  if (!dsn) return; // no-op in local dev without DSN

  SentryLib.init({
    dsn,
    environment: process.env.NODE_ENV,
    enabled: process.env.NODE_ENV === 'production' || !!dsn,
    tracesSampleRate: 0.1,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Non-Error exception captured',
    ],
  });
}

// Export as named 'Sentry' so callers can do: import { Sentry } from '../utils/sentry'
export const Sentry = SentryLib;
